import React, { useState, useRef } from "react";
import { iUsuario } from "../../interfaces/bonita/usuario";
import { AppStore } from "../../redux/store";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { Button } from "antd";
import Input from "../iu/Input";
import styles from "./ForgotPassword.module.less";
import SidebarContent from "../iu/SidebarContent";
import Paragraph from "antd/es/typography/Paragraph";

interface Props {
  username: string;
  email: string;
}
function ForgotPassword() {
  const SelectorUsuarioActivo = useSelector(
    (store: AppStore) => store.usuarioActivo
  );

  const { handleSubmit, control, formState } = useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [inputUsuario, setInputUsuario] = useState("");
  const [inputPass, setInputPass] = useState("");
  const [show, setShow] = useState(false);
  const [glpiSssion_token, SetGlpiSssion_token] = useState({});

  let title = React.createRef();
  let refUsuario = useRef(null);
  type iUarioActivo = iUsuario;

  const [bredirect, setBredirect] = useState(false);
  const [isLogin, setLogin] = useState(true);
  const [serviceLogin, setServiceLogin] = useState("");

  const onSubmit = async (username: string, email: string) => {
    //username, email
    // hacemos la llamada a la api
    //const resultAction = await dispatch(
    //  resetPassword({
    //    username,
    //    email,
    //  })
    //);
    //// success
    //if (resetPassword.fulfilled.match(resultAction)) {
    //  // mostramos un mensaje success
    //  toast.success(
    //    "Se te ha enviado un correo, por favor verifica tu bandeja de entrada."
    //  );
    //  // lo mandamos al home
    //  router.push("/login");
    //}
  };

  const goBack = () => {
    // if (user.changePassword) {
    //    dispatch(logout());
    //    router.back();
    // } else {
    //    router.push('/');
    // }
  };
  return (
    <>
      <div className={styles.alignVerticalFull}>
        {" "}
        <div className={styles.container}>
          <SidebarContent title="Recuperar contraseña">
            {/*'{user.changePassword ? "Ingreso" : "Cambiar contraseña"}'*/}
            <Paragraph strong>
              Si ha olvidado su contraseña ingrese su código de usuario y e-mail
              y pulse el botón Recuperar. En breve le enviaremos una nueva
              contraseña de acceso provisorio al e-mail informado.
            </Paragraph>

            <form
              onSubmit={handleSubmit(() => onSubmit("username", "email"))}
              className={styles.form}
            >
              <div>
                {/*              {error.type === ErrorTypes.RESET_PASSWORD && (
                <Alert
                  message={error.message}
                  type="error"
                  showIcon
                  closable
                />
              )}*/}

                {/* Input user */}
                <Input
                  label="Usuario"
                  name="username"
                  error={formState.errors?.username}
                  rules={{
                    required: "Este campo es obligatorio.",
                    pattern: {
                      value: /^([a-zA-Z0-9\u00f1\u00d1]+)$/,
                      message: "Ingresa solo letras y numeros.",
                    },
                  }}
                  control={control}
                  type={""}
                  text={""}
                  className={""}
                  disabled={false}
                  placeholder={""}
                  min={""}
                  max={""} //uppercase
                />

                {/* Input email */}
                <Input
                  label="Email"
                  name="email"
                  error={formState.errors?.email}
                  control={control}
                  rules={{
                    required: "Este campo es obligatorio.",
                  }}
                  type={""}
                  text={""}
                  disabled={false}
                  min={""}
                  max={""}
                  placeholder={""}
                  className={""}
                />
              </div>
              <div className={styles.wrapperButton}>
                {/* Button cancel */}
                <Button size="large" className={styles.button}>
                  Cancelar
                </Button>
                {/* Button cancel */}
                {/* Button submit */}
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  className={styles.button}
                  loading={loading}
                >
                  Recuperar
                </Button>
              </div>{" "}
            </form>
          </SidebarContent>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
